import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<i class=\"loading--indicator {{if this.useSmallSpinner \'loading-indicator-small-dark\'}}\"></i>\n<div class=\"spinner-label\">\n  <p>{{this.label}}</p>\n</div>", {
  moduleName: "@dashboard/shared-ui/components/spinner-with-label.hbs"
});